document.addEventListener("DOMContentLoaded", () => {
  const btnSubmit = document.querySelector('.section-footer__signup-form .signup-form__button')
  const contactForm = document.getElementById('footer_newsletter_signup')
  if (!contactForm) return

  btnSubmit.addEventListener('click', (event) => {
    event.preventDefault()

    // Validate form
    validateForm(contactForm)
    let isValid = true

    Array.from(contactForm.querySelectorAll('input')).forEach(input => {
      if (input.classList.contains('error')) {
        isValid = false
      }
    })

    if (!isValid) return

    const formData = new FormData(contactForm)

    fetch(contactForm.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => {
        if (response.ok) {
          contactForm.querySelector('.messages-error').classList.add('hidden')
          return response.text()
        }
        contactForm.querySelector('.messages-error').classList.remove('hidden')
      })
      .then(data => {
        if (!data) return
        document.getElementById('hoko_newslatter_form_1').scrollIntoView();
        document.querySelector('.hoko-newletter__description--message').classList.remove('hidden')
        document.documentElement.classList.add('open-message-newletter')
        contactForm.reset()
      })
      .catch(error => {
        contactForm.querySelector('.messages-error').classList.add('hidden')
      })
  })

  function validateForm(form) {
    if (form.querySelector('input.signup-form__email').value === '') {
      form.querySelector('input.signup-form__email').classList.add('error')
    } else {
      form.querySelector('input.signup-form__email').classList.remove('error')
    }

    if (!form.querySelector('input.input_checkbox').checked) {
      form.querySelector('input.input_checkbox').classList.add('error')
    } else {
      form.querySelector('input.input_checkbox').classList.remove('error')
    }
  }
})
